import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Home, Wrench, Search } from 'lucide-react'
import { seg } from '../lib/localizedUrl'

export default function NotFoundPage() {
  const { t, i18n } = useTranslation()

  // Neexistující routa = soft-404. Statická skořápka vrací 200, proto Googlu explicitně
  // řekneme noindex (follow), ať takovou URL nezaindexuje. Po odchodu meta zase odebereme,
  // aby reálné stránky zůstaly indexovatelné.
  useEffect(() => {
    const el = document.createElement('meta')
    el.setAttribute('name', 'robots')
    el.setAttribute('content', 'noindex, follow')
    document.head.appendChild(el)
    return () => { el.remove() }
  }, [])

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center">
      <div className="text-[120px] leading-none font-extrabold bg-gradient-to-r from-primary-600 to-accent-500 bg-clip-text text-transparent select-none">
        404
      </div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mt-2">{t('notfound.title')}</h1>
      <p className="text-gray-500 dark:text-gray-400 mt-2">{t('notfound.desc')}</p>
      <div className="flex flex-wrap items-center justify-center gap-3 mt-8">
        <Link to="/" className="inline-flex items-center gap-2 bg-gradient-to-r from-primary-600 to-primary-500 text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:shadow-lg hover:shadow-primary-500/25 transition">
          <Home className="w-4 h-4" /> {t('notfound.home')}
        </Link>
        <Link to="/tools" className="inline-flex items-center gap-2 border border-gray-200 dark:border-white/15 text-gray-700 dark:text-gray-200 px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-50 dark:hover:bg-white/5 transition">
          <Wrench className="w-4 h-4" /> {t('nav.tools')}
        </Link>
        <Link to={`/${seg('help', i18n.language)}`} className="inline-flex items-center gap-2 border border-gray-200 dark:border-white/15 text-gray-700 dark:text-gray-200 px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-50 dark:hover:bg-white/5 transition">
          <Search className="w-4 h-4" /> {t('nav.help')}
        </Link>
      </div>
    </div>
  )
}
